import { updateAIMatchNotificationSettings } from 'RestAPIs/ai-match';
import { AdminSettings } from 'components/types';
import { useMutation, useQueryClient } from 'react-query';

const useUpdateAIMatchSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: AdminSettings) => {
      const { data } = await updateAIMatchNotificationSettings(payload);
      await queryClient.invalidateQueries('ai-match-settings');
      return data?.[0];
    }
  });
};

export default useUpdateAIMatchSettings;
